import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {AuthGuard} from '@core/services/auth-guard.service';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';

export const securityRoutes: Routes = [
  {
    path: 'users',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'users/manage-request',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'users/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'security/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
];
